import { Component, Injector, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { NgForm, FormArray, FormControl, FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { Step, BnStepperComponent } from "@bndes/bndes-ux4/bn-stepper";
import moment from "moment";
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso, TIPOS_AVISO, TIPO_SEVERIDADE } from 'src/app/model/aviso.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { QuestionarioService } from './questionario.service';
import { QuestionarioAvaliacaoProjetoDTO, PerguntaEnergiaDTO, TipoPerguntaEnum, QuestionarioRespostaEnergiaDTO, OpcaoQuestionarioRespostaEnergiaDTO, MenuQuestionarioModel } from '../model/questionario.model';
import { QuestionarioComplementarComponent } from './bloco-complementar/questionario-complementar.component';
import { QuestionarioAvaliacaoComponent } from './bloco-avaliacao/questionario-avaliacao.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-questionario-menu',
    templateUrl: './questionario-menu.component.html',
    styleUrls: ['./questionario-menu.component.scss'],
    standalone: false
})
export class QuestionarioMenuComponent implements OnInit {
    
    public menuModel: MenuQuestionarioModel;
    public cnpjRascunho: string;
    public numeroRascunho: string;
    public cnpjToken: string;
    public token: string;
        
    constructor(
            private modalService: BnModalMessageService,
            protected injector: Injector,
            private loadingService: BnLoadingService,
            private removerAlertasService: RemoverAlertasService,
            private activatedRoute: ActivatedRoute,
            private alertsService: BnAlertsService,
            private questionarioService: QuestionarioService,
            private router: Router,
            private _modalService: NgbModal) {
            
    }

    ngOnInit() {
    
    }

    public novoQuestionario() {
        this.router.navigate(['/questionario-eficiencia-energetica']);
    }

    public carregarRascunho() {
        if (this.cnpjRascunho && this.cnpjRascunho.trim().length > 0 && this.numeroRascunho && this.numeroRascunho.trim().length > 0) {
            this.router.navigate([`/questionario-eficiencia-energetica/${this.cnpjRascunho}/rascunho/${this.numeroRascunho}`]);
        } else {
            this.alertsService.alertaErro('Erro', 'CNPJ ou Rascunho não informado');
        }
    }

    public carregarToken() {
        if (this.cnpjToken && this.cnpjToken.trim().length > 0 && this.token && this.token.trim().length > 0) {
            this.router.navigate([`/questionario-eficiencia-energetica/${this.cnpjToken}/token/${this.token}`]);
        } else {
            this.alertsService.alertaErro('Erro', 'CNPJ ou Token não informado');
        }
    }
}

